const navContainerProps = {
  active: {
    //wether the menu is currently active or not
    type: Boolean,
    default: false,
  },
  breakpoint: {
    //the breakpoint in pixels where the menu start displaying the button to show the items
    type: Number,
    default: 0,
  },
  responsive: {
    //the state of the menu, it does not change the menu behavior, its used to provide info to parent components
    type: Boolean,
    default: false,
  },
  leftToggle: {
    //wether show the toggle button left instead of right
    type: Boolean,
    default: false,
  },
  fixed: {
    //fix the menu to the top of the page
    type: Boolean,
    default: false,
  },
};

const navElementProps = {
  active: {
    //wether the element is currently active or not
    type: Boolean,
    default: false,
  },
  fixed: {
    //wether the element is not invisible when the menu is inactive and responsive
    type: Boolean,
    default: false,
  },
};

export { navContainerProps, navElementProps };
